var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_1055)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_1055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5135 8.82018L18.1494 7.45608C17.8259 7.13259 17.5613 6.49239 17.5613 6.03316V4.10352C17.5613 3.18507 16.8125 2.43629 15.894 2.43629H13.9644C13.5052 2.43629 12.865 2.17161 12.5415 1.84812L11.1774 0.484018C10.5304 -0.162967 9.46941 -0.162967 8.82017 0.484018L7.45607 1.84812C7.13257 2.17161 6.49011 2.43629 6.03315 2.43629H4.10351C3.18732 2.43629 2.43627 3.18507 2.43627 4.10352V6.03316C2.43627 6.49012 2.1716 7.13259 1.8481 7.45608L0.484006 8.82018C-0.165242 9.46716 -0.165242 10.5281 0.484006 11.1774L1.8481 12.5415C2.1716 12.865 2.43627 13.5074 2.43627 13.9644V15.894C2.43627 16.8102 3.18732 17.5613 4.10351 17.5613H6.03315C6.49237 17.5613 7.13257 17.8259 7.45607 18.1494L8.82017 19.5135C9.46715 20.1605 10.5281 20.1605 11.1774 19.5135L12.5415 18.1494C12.865 17.8259 13.5052 17.5613 13.9644 17.5613H15.894C16.8102 17.5613 17.5613 16.8102 17.5613 15.894V13.9644C17.5613 13.5052 17.8259 12.865 18.1494 12.5415L19.5135 11.1774C20.1605 10.5304 20.1605 9.46943 19.5135 8.82018Z",
    fill: "#2AA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.888 13.7178L5.26172 10.0915L6.84977 8.50345L8.888 10.5417L13.1477 6.28198L14.7358 7.87004L8.888 13.7178Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_1055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueIcon);
export default __webpack_public_path__ + "static/media/true_icon.c6dba2a68913b51c9ff2a58365f01346.svg";
export { ForwardRef as ReactComponent };